import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import {
  GetLiterals,
  GetLiteralsFailed,
  GetLiteralsSuccess,
  GetSelectedLanguage,
  GetSelectedLanguageSuccess,
} from '../actions/literals.actions';
import { LiteralsService } from '../services/literals.service';
import { EliquaFacadeService } from '../services/eliqua.facade.service';

@Injectable()
export class LiteralsEffects {
  constructor(
    private actions$: Actions,
    private literalsService: LiteralsService,
    private eliquaFacade: EliquaFacadeService,
  ) {}

  getLiterals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetLiterals),
      switchMap(() => {
        const lang = this.eliquaFacade.language || 'en';
        return this.literalsService.getLiterals(lang).pipe(
          switchMap((literals) => of(GetLiteralsSuccess({ literals }))),
          catchError((error) => of(GetLiteralsFailed(error))),
        );
      }),
    ),
  );

  getSelectedLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetSelectedLanguage),
      switchMap(() => {
        const selectedLanguage = this.eliquaFacade.language || 'en';
        return of(GetSelectedLanguageSuccess({ selectedLanguage }));
      }),
    ),
  );
}
